import { MODO } from "@/reclutamiento/modo";
import { crearPortalDemo } from "./demo";
import type { PortalApi } from "./tipos";

/** `?ver_como=<cliente_id>` = «Ver como el cliente» desde la interna (solo lectura). */
export async function crearPortalApi(): Promise<PortalApi> {
  const verComo = new URLSearchParams(window.location.search).get("ver_como");
  if (MODO === "supabase") {
    const { crearPortalSupabase } = await import("./supabase");
    return crearPortalSupabase(verComo);
  }
  return crearPortalDemo(verComo);
}

export type { PortalApi, FichaPortal } from "./tipos";
export { ErrorPortal } from "./tipos";
